import { ConversionType } from './UnitToggle';

export const CONVERSION_DIVISORS: Record<ConversionType, number> = {
    INR: 1,
    Lakhs: 1e5,
    Crores: 1e7,
};

/** Currency value in the selected unit, Indian-grouped with 2 decimals. */
export function formatCurrency(value: number, conversionType: ConversionType): string {
    const displayValue = value / CONVERSION_DIVISORS[conversionType];
    return displayValue.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

/** Adaptive compact currency: 3.32 Cr / 45.73 L / 8,540 (used on the landing cards). */
export function formatCompactCurrency(value: number): string {
    const sign = value < 0 ? '-' : '';
    const abs = Math.abs(value);

    if (abs >= 1e7) {
        return `${sign}${(abs / 1e7).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })} Cr`;
    }
    if (abs >= 1e5) {
        return `${sign}${(abs / 1e5).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })} L`;
    }
    return `${sign}${abs.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

export function formatPercent(value: number): string {
    return `${value.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}%`;
}

/** Whole-number days (DSO, credit period); em-dash when unavailable. */
export function formatDays(value: number | null | undefined): string {
    if (value === null || value === undefined) return '—';
    return Math.round(value).toLocaleString('en-IN');
}

export function formatSnapshotDate(snapshot: { year: string; month: number; day: number } | null): string {
    if (!snapshot) return '';
    const startYear = parseInt(String(snapshot.year).split('-')[0], 10);
    const calendarYear = snapshot.month >= 4 ? startYear : startYear + 1;
    const date = new Date(calendarYear, snapshot.month - 1, snapshot.day);
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}
